"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const EmbedReportPage_1 = require("./EmbedReportPage");
const report_1 = require("../../../server/models/report");
const core_1 = require("@material-ui/core");
const useStyles = (0, core_1.makeStyles)(() => ({
    paper: {
        display: 'flex',
        justifyContent: 'center',
    },
    iframe: {
        border: 'none',
        height: '100vh',
        width: '100%',
    },
}));
const EmbedReport = ({ embedReportId, embedReportType, }) => {
    const classes = useStyles();
    const [embedReportUri, setEmbedReportUri] = (0, react_1.useState)('');
    const selectedSiteIds = [];
    const [syncExternalSiteFilter, setSyncExternalSiteFilter] = (0, recoil_1.useRecoilState)(EmbedReportPage_1.syncExternalSiteFilterState);
    const iframeRef = (0, react_1.useRef)(null);
    const embedHostUrl = localStorage.getItem('embed_host') ?? '';
    const [showSpinner, setShowSpinner] = (0, react_1.useState)(false);
    const getReport = (0, react_1.useCallback)(() => {
        setShowSpinner(true);
        (0, report_1.getEmbedReportUri)(embedReportId, embedReportType, selectedSiteIds)
            .then((uri) => {
            return setEmbedReportUri(uri);
        })
            .finally(() => setShowSpinner(false));
    }, [embedReportId, embedReportType]);
    const onExternalFilterChange = (0, react_1.useCallback)(() => {
        try {
            if (syncExternalSiteFilter) {
                iframeRef?.current?.contentWindow?.postMessage((0, report_1.getFilterUpdatePostMessage)(embedReportType, selectedSiteIds), embedHostUrl);
                iframeRef?.current?.contentWindow?.postMessage((0, report_1.getReportRunMessage)(embedReportType), embedHostUrl);
            }
        }
        finally {
            setSyncExternalSiteFilter(false);
        }
    }, [syncExternalSiteFilter]);
    (0, react_1.useEffect)(() => {
        onExternalFilterChange();
    }, [onExternalFilterChange]);
    (0, react_1.useEffect)(() => {
        getReport();
    }, [getReport]);
    return (react_1.default.createElement(core_1.Paper, { elevation: 0, className: classes.paper }, showSpinner ? (react_1.default.createElement(core_1.CircularProgress, null)) : (react_1.default.createElement("iframe", { ref: iframeRef, id: "ec-si-embed-iframe", src: embedReportUri, className: classes.iframe }))));
};
exports.default = EmbedReport;
